import React from 'react';
import ReactDOM from 'react-dom/client';

import AccommodationSearch from './AccommodationSearch';

const root = ReactDOM.createRoot(
  document.getElementById('accommodation_search')
);

root.render(
  <React.StrictMode>
    <AccommodationSearch />
  </React.StrictMode>
);
